import { DrawingToolHelpers } from "../../../helpers/drawing-tool-helpers";
import { IComponent } from "../../component.interface";
import { IDrawingTool } from ".././drawing-tool.interface";
import { DrawingToolsManager } from ".././drawing-tools.manager";

export class VerticalArrowComponent implements IComponent, IDrawingTool {
    public id = '';

    public annotation: any = null;
    private drawingToolManager: DrawingToolsManager;

    constructor(drawingToolManager: DrawingToolsManager, id: string) {
        this.drawingToolManager = drawingToolManager;
        this.id = id;
    }

    public static syncCreate(drawingToolManager: DrawingToolsManager, annotationOptions: any): VerticalArrowComponent {
        const chart: any = drawingToolManager.base.tiChartSeries.highStockChart;
        
        annotationOptions.typeOptions.point.x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.point.actualXValue,
            annotationOptions.typeOptions.point.actualStartTimeT,
            drawingToolManager);

        const component = new VerticalArrowComponent(drawingToolManager, annotationOptions.id);
        const addedNewAnnotation: any = chart.addAnnotation(annotationOptions);

        drawingToolManager.updateAnnotationStyles(addedNewAnnotation, annotationOptions, false);
        component.annotation = addedNewAnnotation;
        return component;
    }

    public static create(drawingToolManager: DrawingToolsManager, event: any): VerticalArrowComponent {
        const component = new VerticalArrowComponent(drawingToolManager, event.options.id);
        component.annotation = event;
        return component;
    }

    public syncUpdate(annotationOptions: any) {
        if (!annotationOptions?.typeOptions?.point) {
            return;
        }

        annotationOptions.typeOptions.point.x = DrawingToolHelpers.calculateXPosition(
            annotationOptions.typeOptions.point.actualXValue,
            annotationOptions.typeOptions.point.actualStartTimeT,
            this.drawingToolManager);

    }

    public getMetaData(): any {
        if (!this.annotation.options?.typeOptions?.point) {
            return null;
        }

        const firstPoint = this.annotation.options.typeOptions.points[0];
        const actualFirstPosition = DrawingToolHelpers.getActualStartTimePosition(firstPoint, this.drawingToolManager);

        return {
            id: this.id,
            langKey: "verticalArrow",
            type: 'verticalLine', // options type
            shapeOptions: {
                stroke: this.annotation.options.shapeOptions.stroke,
                strokeWidth: this.annotation.options.shapeOptions.strokeWidth,
            },
            typeOptions: {
                label: {
                    offset: this.annotation.options.typeOptions.label.offset,
                    format: this.annotation.options.typeOptions.label.format
                },
                point: {
                    x: firstPoint.x,
                    actualStartTimeT: actualFirstPosition?.actualStartTimeT,
                    actualXValue: actualFirstPosition?.actualXValue,

                    y: firstPoint.y,

                    xAxis: this.annotation.options.typeOptions.point.xAxis,
                    yAxis: this.annotation.options.typeOptions.point.yAxis
                },
                connector: {
                    fill: this.annotation.options.typeOptions.connector.fill,
                    stroke: this.annotation.options.typeOptions.connector.stroke
                }
            }
        };
    }
}